import styled from 'styled-components'
import { themeMedia, themeStyles } from '../../../styles/theme'

const headerHeight = '3rem'

export const GameScreenshotContent = styled.div`
  height: calc(100vh - ${headerHeight});
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;

  img {
    width: 100%;
    max-height: 550px;
  }

  ${themeMedia.tablet`
    height: 100%;
    padding: 3rem 6rem 0 6rem;
  `}
`

export const GameScreenshotHeader = styled.div`
  display: flex;
  height: ${headerHeight};
  align-items: center;
  background-color: ${themeStyles.colors.black.main};

  span {
    margin: 0 auto;
    text-align: center;
    color: ${themeStyles.colors.white.main};
  }

  img {
    position: absolute;
    top: 1rem;
    right: 1rem;
    width: 1rem;
    height: 1rem;
    cursor: pointer;
  }

  ${themeMedia.tablet`
    background-color: ${themeStyles.colors.darkGreys[3].main};
    height: 0;

    span {  
      display: none;
    }
    
    img {
      width: .8rem;
      height: .8rem;
      top: 1.25rem;
      right: 1.25rem;
    }
  `};
`

export const GameScreenshotContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const GameScreenshotDescription = styled.p`
  text-wrap: wrap;
  text-align: center;
  font-size: 1rem;
  line-height: 1.4;
  color: ${themeStyles.colors.white.main};
  ${themeMedia.desktop`
    text-align: left;
  `}
`
